import type { NextPage } from 'next'
import { useRouter } from 'next/router'

import type { Item } from '@/modules/project'

import Dayjs from '@/components/dayjs'
import CircleIcon from '@/components/svgIcons/Circle'

import style from './item.module.css'


interface IProps {
  item: Item
}


const Component: NextPage<IProps> = ({ item }) => {
  const colGroupType: string = 'type2';

  return (
    <section>
      <h2 className={style.h2}>
        <CircleIcon /> 협의진행 상황
      </h2>
      <div>
        <table className={style.inContractTable}>
          {colGroupType === 'type1' && (
            <colgroup>
              <col width={200}/>
              <col width={500}/>
              <col width={500}/>
            </colgroup>
          )}
          {colGroupType === 'type2' && (
            <colgroup>
              <col width={400}/>
              <col width={400}/>
              <col width={400}/>
            </colgroup>
          )}
          <thead>
            <tr>
              <th>단계</th>
              <th>접수일</th>
              <th>통보일</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th className='!border-l-0'>평가준비서 접수</th>
              <td colSpan={2}><Dayjs format="dateDot">{item.preparationFormRegisteredDate}</Dayjs></td>
            </tr>
            <tr>
              <th className='!border-l-0'>초안</th>
              <td><Dayjs format="dateDot">{item.draftRegisteredDate}</Dayjs></td>
              <td><Dayjs format="dateDot">{item.draftNoticedDate}</Dayjs></td>
            </tr>
            <tr>
              <th className='!border-l-0'>본안</th>
              <td><Dayjs format="dateDot">{item.mainProposalRegisteredDate}</Dayjs></td>
              <td><Dayjs format="dateDot">{item.mainProposalNoticedDate}</Dayjs></td>
            </tr>
            <tr>
              <th className='!border-l-0'>보완</th>
              <td><Dayjs format="dateDot">{item.redeemRegisteredDate}</Dayjs></td>
              <td><Dayjs format="dateDot">{item.redeemNoticedDate}</Dayjs></td>
            </tr>
            <tr>
              <th className='!border-l-0'>재보완</th>
              <td><Dayjs format="dateDot">{item.redeemAgainRegisteredDate}</Dayjs></td>
              <td><Dayjs format="dateDot">{item.redeemAgainNoticedDate}</Dayjs></td>
            </tr>
            <tr>
              <th className='!border-l-0'>협의완료</th>
              <td colSpan={2}><Dayjs format="dateDot">{item.consultationCompletionDate}</Dayjs></td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  )
}

export default Component
